import curry from "../../../lib/core/functional/curry";

const renderModule = curry(function renderLoadMoreModule({ h }, _context, _deps, _altLoader) {
    function Module(props) {
        const { loadMoreComments, hasMore } = props;
        return hasMore ? (
            <div onClick={loadMoreComments} class="talks--load_more">
                Show more comments
            </div>
        ) : null;
    }
    return Module;
});

export default function loadMore({ preact }) {
    return renderModule(preact);
}
